<template>
    <section class="mt-16">
        <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0"
        ></v-breadcrumbs>

        <h1 class="primary--text">
            <v-icon color="primary">mdi-account-multiple</v-icon> <span>Gestão de Sistema</span>
        </h1>

        <v-container fluid>

            <v-card class="elevation-2 mt-2" v-if="$store.getters.hasRole(['super'])">
                <v-card-title class="primary white--text">
                    Jobs
                </v-card-title>
                <v-card-text>                  
                    <JobsPlanner />
                </v-card-text>
            </v-card>
        </v-container>
    </section>
</template>
<script>
//import System from "@/api/System.js"
import JobsPlanner from '@/components/jobs_planner/JobsPlanner.vue'

export default{
    name: "System",
    components:{
        JobsPlanner
    },
    data(){
        return{
            loading: true,
            status: null,
            success: false,
        }
    },
    mounted(){        
        if(!this.$store.getters.hasPermission(["super"])) {
            this.$router.push('/no-permission');
        }

        //this.fillBaseData()
    },
    methods:{
        /*
        fillBaseData(){
            System.getStatus().then((resp)  =>  {
                this.status = resp.data.value == "0" ? false : true

                this.loading = false
            })
        },
        saveSystemConfig(){
            this.loading = true
            let data = {
                maintenance: this.status
            }
            System.setStatus(data).then(()  =>  {
                this.loading = false

                window.location.reload();
            })
        },
        */
    },
    computed: {
        crumbs: function() {
        return [
            {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
            },
            {
            text: 'Gestão de Sistema',
            disabled: true,
            to: window.location.href,
            exact: true,
            },
        ];
        }
    }
}
</script>